export default __webpack_public_path__ + "static/media/004-A-Caf.d57edc0e.svg";